<!--
 © Copyright 2026 Daikin Industries, Ltd. All rights reserved.

 This software is the proprietary information of Daikin Industries, Ltd.
 By using this software, you agree to the following terms:

 1. You are granted a revocable non-exclusive, non-transferable license to use this software.
 2. You agree not to modify, distribute, or create derivative works based on this software.
 3. Unauthorized copying, distribution, or use of any portion of this software is strictly prohibited.
 4. This software is protected by copyright laws and international treaties.
 5. Any violation of these terms will result in the termination of your license and may result in legal action.
 6. This is Daikin's proprietary software and may not be used in an unauthorized manner or without express authorization from Daikin.
-->

<div class="confirmation-container">
  <article class="confirmation-article">
    <header class="confirmation-header">
      <h1 class="confirmation-title">Congratulations!</h1>
    </header>

    <section class="confirmation-content">
      <p class="confirmation-message">
        You are now successfully registered in the <b>Daikin ADC Network</b> and have been granted access to <b>API Mesh (Athena)</b>.
      </p>

      <p class="setup-instruction">
        Please use the following link to get information <a href="/api-mesh/overview#getting-started" class="setup-link">How to Setup and Use Athena</a>
      </p>
    </section>
  </article>
</div>
